export const COLUMNS = [
  'table.header.name',
  'table.header.status',
  'table.header.lastRun',
  'table.header.nextRun',
  'table.header.recurrence',
  'table.header.latestFile',
]

export const ACTIONS = [
  {
    icon: 'download',
    event: 'download',
    name: 'table.actions.download',
  },
]
